/**
 * DTOs de endpoints de webhook de un módulo (`/modules/:code/webhooks`) y sus entregas. Ver
 * docs/FASE-0.md §5 "Webhooks" y §3 `webhook_endpoints`/`webhook_deliveries`. Los eventos que
 * viajan a esos endpoints usan `WebhookEventSchema` de `../webhooks.js`.
 */
import { z } from "zod";
import { PATTERNS, WEBHOOK_EVENTS } from "../constants.js";
export const CreateWebhookEndpointInputSchema = z.object({
    url: z.url(),
    events: z.array(z.enum(WEBHOOK_EVENTS)).min(1),
});
/** Sin valores explícitos en FASE-0 §3; `active`/`disabled` es la decisión mínima razonable (igual que `packages/db`). */
export const WebhookEndpointStatusSchema = z.enum(["active", "disabled"]);
export const WebhookEndpointSchema = z.object({
    id: z.uuid(),
    moduleCode: z.string().regex(PATTERNS.MODULE_CODE),
    url: z.url(),
    events: z.array(z.enum(WEBHOOK_EVENTS)),
    status: WebhookEndpointStatusSchema,
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
/**
 * Respuesta de `POST /modules/:code/webhooks` y de
 * `POST /modules/:code/webhooks/:id/rotate-secret` (hallazgo 6 de la revisión de seguridad: cada
 * endpoint tiene su propio secreto aleatorio, en vez de compartir `WEBHOOK_DEFAULT_SECRET`):
 * lleva además `secret` en claro, la ÚNICA vez que se devuelve — ni `GET /modules/:code/webhooks`
 * ni ninguna otra respuesta lo incluyen después.
 */
export const WebhookEndpointCreatedSchema = WebhookEndpointSchema.extend({
    secret: z.string(),
});
export const WebhookDeliveryStatusSchema = z.enum(["pending", "delivered", "failed"]);
export const WebhookDeliverySchema = z.object({
    id: z.uuid(),
    endpointId: z.uuid(),
    eventType: z.string(),
    attempt: z.number().int().nonnegative(),
    status: WebhookDeliveryStatusSchema,
    responseStatus: z.number().int().nullable(),
    nextAttemptAt: z.iso.datetime().nullable(),
    deliveredAt: z.iso.datetime().nullable(),
    createdAt: z.iso.datetime(),
});
//# sourceMappingURL=webhooks.js.map